import { render, staticRenderFns } from "./BasePanel.vue?vue&type=template&id=05008f15&scoped=true&"
import script from "./BasePanel.vue?vue&type=script&lang=js&"
export * from "./BasePanel.vue?vue&type=script&lang=js&"
import style0 from "./BasePanel.vue?vue&type=style&index=0&id=05008f15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05008f15",
  null
  
)

export default component.exports